<template>
    <div>
    	<router-view></router-view>
    	<div class="header">
        <div style="display:flex">
          <p class="size">结算周期</p>
          <p class="button1" @mouseover="enter" @mouseout="leave">?</p>
         </div>
	     <el-button type="primary"  @click="AddRatee" class="button">+ 新增模板</el-button>
	    </div>
		 <el-table
		    :data="tableData"
		    stripe
		    :header-cell-style="cell"
        :row-style="height"
		    style="width: 100%;">
		    <el-table-column	align="center" prop="day" label="风险预存期" ></el-table-column>
		    <el-table-column	align="center" prop="feeRate"  label="平台手续费"> </el-table-column>
		    <el-table-column	align="center" prop="type"  label="提现渠道" :formatter="typeFormat"> </el-table-column>
		    <el-table-column  align="center" label="操作" style="text-align: center;">
		      <template slot-scope="scope">
		        <el-button type="text" size="small" @click="comRate(scope.row.day,scope.row.feeRate,scope.row.feeId)">编辑</el-button>
		        <el-button type="text" size="small" style="color: red;" @click="DelRate(scope.row.day,scope.row.feeRate,scope.row.feeId,scope.row.type)">删除</el-button>
		      </template>
		    </el-table-column>
		 </el-table>


		<el-dialog title="结算周期" width="500px"  :visible.sync="dialogFormVisible">
        <div class="border"></div>

      <div style="text-align: center;">
        <span class="xian">风险预存期</span>
        <span>T+</span>
         <input  style="width: 255px;"  class="input" v-model="form.day" placeholder="请输入提现时间周期"></input>
         <span>&nbsp&nbsp&nbsp</span>
      </div>
      <div class="textRa">*风险预存期的最少时间为1天*</div>
       <div class="Rate" >
        <span class="tixian">平台手续费</span>
        <input class="input" v-model="form.feeRate" placeholder="请输入提现费率"></input>
        <span>%</span>
      </div> 
      <div class="Rate">
        <el-radio v-model="form.type" label="1" class="tixian">园区钱包</el-radio>
        <el-radio v-model="form.type" label="2" class="tixian">第三方平台</el-radio>
      </div>
      
		  <div slot="footer" class="dialog-footer" >
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button  class="sure" @click="AddRate">确 定</el-button>
		  </div>
		</el-dialog>
      <div class="pageWrap">
       <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <div class="chuang"   v-show="chuang">
        <p>*风险预存期： <br/>为保护户商户产品/服务质量、避免违约纠纷等交易风险，而设定的交易在完成后的一定时间内不得进行结算的时间段。<br/>
        例：T+1 当天的资金收入，次日结算；<br/>
          T+7 当天的资金收入，在七天以后结算;<br/>
        *提现金额按照谈好的的费率收取手续费，手续费的计算精确到小数点的后俩位。</p>
      </div>
    </div>
  	 
</template>

<script>
import {
  AddRate,
  selectAllRate,
  delRate,
  EditRate
} from "@/api/merchant/merchManage";
export default {
  name: "",
  props: [""],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      chuang:false,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: "100px",
      formLabelWidth1: "150px",
      form: {
        day: "",
        feeRate: "",
        feeId: "",
        type:'1'
      },
      tableData: []
    };
  },
  methods: {
    cell() {
      return { textAlign: "center" ,background:"#FAFAFA"};
    },
     height() {
      return {height:"2px"};
    },
    AddRatee() {
      this.form.day="";
       this.form.feeRate="";
      this.dialogFormVisible = true;
    },
    //分页查询模板数据
    selectAllRate(page, rows) {
      let _this = this;
      selectAllRate(page, rows).then(function(res) {
        _this.total = res.data.count;
        for (var i = 0; i <= res.data.list.length - 1; i++) {
          res.data.list[i].feeId = res.data.list[i].feeId;
          res.data.list[i].day = "T+" + res.data.list[i].day;
          if(String([res.data.list[i].feeRate]).indexOf(".")==-1){
           res.data.list[i].feeRate = res.data.list[i].feeRate+ ".0%";
          }else{
               res.data.list[i].feeRate = res.data.list[i].feeRate+ "%";
          }
        
        }
        //赋值分页查询数据
        _this.tableData = res.data.list;
      });
    },
    //添加模板数据
    AddRate() {
      let day = this.form.day;
      let feeRate = this.form.feeRate;
      let id = this.form.feeId;
      let type = this.form.type;
      let _this = this;
      if(day<1){
        alert('请正确填写风险预存期');
        return ;
      }
      if(feeRate<0||!feeRate){
         alert('请正确填写提现费率');
        return ;
      }

      if (id) {
        EditRate(id, day, feeRate,type)
          .then(function(res) {
            console.log(res)
            if (res.data.msg == "success") {
              _this.dialogFormVisible = false;
              _this.$notify({
                title: "成功",
                message: "费率模板修改成功",
                type: "success"
              });
              _this.selectAllRate(_this.currentPage, _this.pageSize);
            }else{
                _this.dialogFormVisible = false;
              _this.$notify({
                title: "失败",
                message: "模板已存在，请重新添加！",
                type: "warning"
              });
            }
          })
          .catch(function(error) {
            _this.dialogFormVisible = false;
            _this.$notify({
              title: "失败",
              message: "费率模板修改失败",
              type: "warning"
            });
            _this.selectAllRate(_this.currentPage, _this.pageSize);
          });
      } else {
        AddRate(day, feeRate,type)
          .then(function(res) {
            if (res.data.msg  == "success") {
              _this.dialogFormVisible = false;
              _this.$notify({
                title: "成功",
                message: "费率模板添加成功",
                type: "success"
              });
              _this.selectAllRate(_this.currentPage, _this.pageSize);

            }else{
              _this.dialogFormVisible = false;
              _this.$notify({
                title: "失败",
                message: "模板已存在，请重新添加！",
                type: "warning"
              });
            }
          })
          .catch(function(error) {
            _this.dialogFormVisible = false;
            _this.$notify({
              title: "失败",
              message: "费率模板添加失败",
              type: "warning"
            });
          });
      }
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.selectAllRate(page, this.pageSize);
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
    },
    //删除
    DelRate(day, feeRate, id) {
      let _this = this;
      this.$confirm("确定删除“" + day + " " + feeRate + "“" + "，删除后不可撤销", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const __this = this;
          delRate(id)
            .then(function(res) {
              if (res.data.msg === "success") {
                _this.selectAllRate(_this.currentPage, _this.pageSize);
                __this.$message({
                  type: "success",
                  message: "删除成功"
                });
              }
            })
            .catch(function() {
              __this.$message({
                type: "info",
                message: "删除失败"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //编辑费率模板
    comRate(day, feeRate, feeId) {
      this.form.day = day.replace("T+", "");
      this.form.feeRate = feeRate.replace("%", "");
      this.form.feeId = feeId;
      this.dialogFormVisible = true;
    },
    enter: function(){
        this.chuang = true;
        },
    leave: function(){
        this.chuang = false;
    },
    typeFormat(row, column){
      let typeStr = row[column.property]
      switch(typeStr){
        case 1:
          return '园区钱包'
        break;
        case 2:
        return '第三方平台'
        break;
      }
    }
  },
  created() {
    let page = this.currentPage;
    let rows = this.pageSize;
    this.selectAllRate(page, rows);
  }
};
</script>
<style lang="scss" scoped>
$border-color: #ececec;
.header {
  display: flex;
  justify-content: space-between;
}
.button1 {
  height: 20px;
  width: 20px;
  border-radius: 10px;
  margin-left: 10px;
  margin-top: 18px;
  text-align: center;
  line-height: 20px;
  border: 1px solid #636161;
 
}
.button {
  height: 35px;
  line-height: 10px;
  margin-right: 20px;
}

.pageWrap {
  margin-top: 20px;
  text-align: center;
}
.Rate {
  margin-top: 10px;
  text-align: center;
}
.tixian {
  padding-right: 20px;
}
.input {
  height: 35px;
  width: 60%;
  padding-left: 10px;
  border: 1px solid #d5d5d5;
  border-radius: 2px;
}
.xian {
  padding-right: 6px;
}
.chuang{
  z-index: 2;
  font-size: 14px;
  position: absolute;
  top: 50px;
  left:112px;
  width: 280px;
  background-color:#fff;
  padding: 5px 10px;
  box-shadow: 2px 2px 10px 1px  #a4a4a4
}
  .dialog-footer {
    margin: 0 -15px -15px;
    padding: 10px 15px;
    border-top: 1px solid $border-color;
    background-color: #f7f7f7;
    .el-button.sure{
      background-color: #31cf86;
      font-size: 14px;
      color: #fff;
    }
  }
  .border {
    margin: -30px -20px 20px;
    border-bottom: 1px solid $border-color;
  }
  .size{
    font-size: 18px;
  }
  .textRa{
    padding-top: 10px;
    text-align: center;
    color: #d5d5d5

  }
</style>



// WEBPACK FOOTER //
// src/pages/merchant/ratetpl.vue